// extracted by mini-css-extract-plugin
export var centerText = "_c9-8";
export var container = "_c9-0";
export var doughnutContainer = "_c9-7";
export var legend = "_c9-a";
export var legendItemColorDisplay = "_c9-b";
export var legendItemLabel = "_c9-d";
export var legendItemValue = "_c9-c";
export var lg = "_c9-5";
export var maxWidth = "_c9-9";
export var md = "_c9-4";
export var responsive = "_c9-6";
export var sm = "_c9-3";
export var xs = "_c9-2";
export var xxs = "_c9-1";